import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { googlemapcenteraction, InfoBoxCenterAction } from "./actions";
const useGeoLocation = () => {
    var center = useSelector(state => state.MapCenterPoint)
    var dispatch = useDispatch();
    const [location, setLocation] = useState({
        loaded: false,
        coordinates: { lat: "", lng: "" },
    });
    const onSuccess = ( location ) => {
        if ( !center.init ) {
            return;
        }
        setLocation( { loaded: true, coordinates: { lat: location.coords.latitude, lng: location.coords.longitude } } );
        dispatch(googlemapcenteraction( { init: false, coordinates: { lat: location.coords.latitude, lng: location.coords.longitude } } ));
        dispatch(InfoBoxCenterAction( { lat: location.coords.latitude, lng: location.coords.longitude } ));
    };
    const onError = ( error ) => { setLocation( { loaded: true, error: { code: error.code, message: error.message } });
    }
    useEffect(() => {
        if (!("geolocation" in navigator)) {
            onError({ code: 0, message: "Geolocation not supported" });
        }
        if ( center.init ) {
            navigator.geolocation.getCurrentPosition(onSuccess, onError);
        }
    }, [location]);
    return location;
};
export default useGeoLocation;